import { FormItemContainer, FormItemProps } from "./FormItemContainer";

type Props = FormItemProps<boolean> & {
  value?: boolean;
  onChange: (value: boolean) => void;
  dataCy?: string;
};

export const FormSwitch = (props: Props) => {
  //
  const { value, onChange, dataCy } = props;

  return (
    <FormItemContainer<boolean> {...props} additionalClassNames="switch">
      <label className="form-switch">
        <input
          type="checkbox"
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
          data-cy={dataCy}
        />
        <i></i>
      </label>
    </FormItemContainer>
  );
};
